/**Recibo para reclamo */
export class ComplaintConcept {
    public InterloculorComercial : string;
    public NroDocumentoOficial   : string;    
    public Anno                  : string;              
    public Mes                   : string;
    public FechaEmision          : string;    
    public FechaVencimiento      : string;    
    public CodConcepto           : string;
    public DesConcepto           : string;    
    public Importe               : string;
    /**Lista de items */
    public itemList              : string[]; 
}


